import apiClient from '../client'

export interface PermissionResponse {
  id: string
  code: string
  displayName: string
  description: string | null
  module: string
  action: string
  isSystem: boolean
}

export interface RolePermissionsResponse {
  roleId: string
  roleCode: string
  roleName: string
  tenantId: string | null
  isSystemRole: boolean
  assignedPermissionIds: string[]
}

export interface UpdateRolePermissionsRequest {
  permissionIds: string[]
}

export const permissionsService = {
  async list(): Promise<PermissionResponse[]> {
    return apiClient.get<PermissionResponse[]>('/permissions')
  },

  async getForRole(roleId: string): Promise<RolePermissionsResponse> {
    return apiClient.get<RolePermissionsResponse>(`/roles/${roleId}/permissions`)
  },

  async updateForRole(roleId: string, body: UpdateRolePermissionsRequest): Promise<RolePermissionsResponse> {
    return apiClient.put<RolePermissionsResponse, UpdateRolePermissionsRequest>(
      `/roles/${roleId}/permissions`,
      body,
    )
  },
}
